import type {SyntheticEvent} from 'react'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {CenteredPage} from '@freckle/school/ts/common/components/common/centered-page'
import {logout} from '@freckle/school/ts/common/components/dashboard/logout'

function handleLogout(_e: SyntheticEvent<EventTarget, Event>) {
  logout()
}

export default function NoSchools() {
  const {t} = useSafeTranslation()
  const supportLink = <Link href="mailto:support@freckle.com" reactRouter={false} />
  return (
    <CenteredPage>
      <H1>{t('NO_SCHOOLS_AVAILABLE_PAGE_TITLE')}</H1>
      <p>
        <SafeTrans
          i18nKey="NO_SCHOOLS_AVAILABLE_DESCRIPTION_TEXT_LINK"
          components={{supportLink}}
        />
      </p>
      <Button onClick={handleLogout}>{t('NO_SCHOOLS_AVAILABLE_LOGOUT_BTN_TEXT')}</Button>
    </CenteredPage>
  )
}
